module.exports = __webpack_public_path__ + "static/media/icnAlertInfo.1890e851.svg";